module.exports = __webpack_public_path__ + "img/travel-medi-banner.ed06032f.png";